<template>
  <div class="popup-container" v-if="show">
    <div class="masking"></div>
    <div class="modal">
      <div class="header">
        <span>修改密码</span>
        <!-- <img :src="require('@/assets/images/icon_xx3.png')" alt="" class="icon-close" @click="close "> -->
        <i class="el-icon-close c-pointer"  @click="close "></i>
      </div>
      <div class="info">
        <div class="info-item">
          <i>*</i>
          <span>当前密码</span>
          <input type="password" v-model="pwdList.curent">
        </div>
        <div class="info-item">
          <i>*</i>
          <span class="span2">新密码</span>
          <input type="password" v-model="pwdList.new">
        </div>
        <div class="info-item">
          <i>*</i>
          <span>确认密码</span>
          <input type="password" v-model="pwdList.confim">
        </div>
      </div>
      <div class="submit" @click="submit">保存</div>
    </div>
    <error v-if="errorShow">{{message}}</error>
  </div>
</template>
<script>
import error from '../../../../components/error.vue';

export default {
  components: { error },
  data() {
      return {
        show:false,
        pwdList: {
          curent: '',
          new:'',
          confim:''
        },
        message:'',
        errorShow:false

      };
    },
    
    methods: {
      verify(){ 
        for(let item in this.pwdList){
          if(!this.pwdList[item]){
            return false
          }
        }
        return true
      },
      submit() {
        if(!this.verify()){
          this.errorShow = true
          this.message = "密码不能为空"
        }
        else if(this.pwdList.new !=this.pwdList.confim){
            this.errorShow = true
          this.message = "两次密码输入不一致"
        }else{
          this.$api.POST_RESETPWD({
             oldPassword:this.pwdList.curent,
             newPassword:this.pwdList.new,
          }).then(res=>{
            if(res.status){
               this.show = false;
               this.$parent.success(true)
               this.$store.commit('LOGINOUT')
               this.$router.push({path:'/login',query:{type:1}})
               
            }
            else{
                this.errorShow = true
                this.message = res.message
            }
          })
         
        }
      },
      close(){
          this.show =! this.show
          this.pwdList.curent = ''
          this.pwdList.new = ''
          this.pwdList.confim = ''

      },
      error(){
         this.errorShow = false
      }
      
    }
}
</script>
<style lang="scss" scoped>
.modal{
  padding:20px 30px;
  width: 550px;
  height: 350px;
  .header{
      margin-bottom: 26px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      justify-content: space-between;
      span{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

    }
    .info-item{
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: 20px;
      i{
        position: relative;
        top: 2px;
        margin-right: 4px;
        color: #fa4b4b;
      }
      span{
        width: 80px;
        white-space: nowrap;
        margin-right: 12px;
        color: #606266;
      }
      .span2{
        letter-spacing: 0.5em;
      }
      input{
        width: 100%;
        border: 1px solid #f5f5f5;
        height: 40px;
        border-radius: 3px;
        padding-left: 20px;
      }
    }
    .submit{
      background: #fa4b4b;
      font-size: 16px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      width: 80%;
      margin: 15px auto;
      border-radius: 4px;
      cursor: pointer;
    } 
}
</style>


// WEBPACK FOOTER //
// src/pages/person/components/person-center/person-pwd-popup.vue